<div *ngIf="loading" class="flex justify-center py-10">
  <nz-spin nzSimple nzSize="large"></nz-spin>
</div>
<div class="bg-white rounded-md overflow-clip pb-4" *ngIf="!loading">
  <div class="px-5 py-4 font-semibold">
    {{ ageLevelLabel }}
  </div>
  <nz-divider class="m-0"/>


  <div class="flex flex-col gap-4">
    <ng-container *ngFor="let template of templates; let i = index">
      <ng-container *ngIf="i < visibleTemplatesCount">
        <app-admin-resource-category-template-week
          [template]="template"
          (change)="handleTemplateChange(i, template)"
          (delete)="handleDeleteTemplate(i)"
        ></app-admin-resource-category-template-week>
      </ng-container>
    </ng-container>
  </div>

  <div class="px-4 flex flex-col gap-4 mt-4">
    <div *ngIf="visibleTemplatesCount >= templates.length; else loadMore">
      <button nz-button nzType="dashed" (click)="handleAddTemplate()" nzSize="large" nzBlock="true">
        添加周
      </button>
    </div>
    <ng-template #loadMore>
      <button nz-button nzType="dashed" (click)="loadMoreTemplates()" nzSize="large" nzBlock="true">
        加载更多
      </button>
    </ng-template>
    <div>
      <button nz-button nzType="primary" (click)="handleSubmit()" nzSize="large" class="px-10" [nzLoading]="saving">
        保存
      </button>
    </div>
  </div>

</div>
